import { Button, Card } from '@design-system';

import { ClipboardCheck, PhoneCall, Sparkles } from 'lucide-react';

import type { ReactNode } from 'react';

interface LicensedDoneProps {
  clientFirstName: string;
  onClose?: () => void;
}

interface NextStep {
  icon: ReactNode;
  title: string;
  description: string;
}

export function LicensedDone({ clientFirstName, onClose }: LicensedDoneProps) {
  const steps: NextStep[] = [
    {
      icon: <ClipboardCheck className="size-5" />,
      title: 'We review your goals',
      description: `Our licensed team looks at what you're planning for ${clientFirstName}.`,
    },
    {
      icon: <PhoneCall className="size-5" />,
      title: 'We reach out today',
      description: 'A licensed expert contacts you to talk through your options.',
    },
    {
      icon: <Sparkles className="size-5" />,
      title: 'We build the plan together',
      description: `We tailor a long-term care plan to ${clientFirstName}'s needs.`,
    },
  ];

  return (
    <div className="mx-auto w-full max-w-lg">
      <div className="flex flex-col items-center text-center">
        <h1 className="mt-6 text-balance text-3xl font-bold text-gray-950">You&apos;re all set</h1>
        <p className="text-foreground mt-2 text-balance">
          Someone from our licensed support team will reach out to you today to discuss your
          planning goals for {clientFirstName}.
        </p>
      </div>

      <Card className="mt-6 p-6 shadow-none">
        {steps.map(step => (
          <div
            key={step.title}
            className="flex items-start gap-4 text-start"
          >
            <span className="bg-primary/10 text-primary flex size-11 shrink-0 items-center justify-center rounded-md">
              {step.icon}
            </span>
            <div>
              <p className="font-medium text-gray-950">{step.title}</p>
              <p className="text-foreground text-sm">{step.description}</p>
            </div>
          </div>
        ))}
      </Card>

      {onClose && (
        <Button
          size="lg"
          onClick={onClose}
          className="mt-6 w-full"
        >
          Back to clients
        </Button>
      )}
    </div>
  );
}
